/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'magic-stars': {
    width: 21,
    height: 20,
    viewBox: '0 0 21 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M18.402 5.685a.163.163 0 010 .3l-1.69.737a1.762 1.762 0 00-.91.911l-.736 1.685a.164.164 0 01-.3 0l-.714-1.655a1.765 1.765 0 00-.907-.917l-1.72-.761a.163.163 0 010-.3l1.69-.737c.407-.177.734-.502.911-.91l.738-1.69a.163.163 0 01.299 0l.737 1.69c.177.406.503.733.911.91l1.53.668.159.07h.002zm-3.655 5.533a.283.283 0 01-.004.517l-2.921 1.275a3.06 3.06 0 00-1.578 1.578L9.09 17.23l-.12.276a.282.282 0 01-.52 0L7.217 14.64a3.06 3.06 0 00-1.57-1.586L2.67 11.74a.283.283 0 010-.52l2.927-1.276a3.06 3.06 0 001.578-1.578L8.45 5.443c.1-.227.419-.227.519 0l1.275 2.922a3.06 3.06 0 001.578 1.578l2.921 1.275v-.002l.004.002z" _fill="#1F222C"/>'
  }
})
